// extracted by mini-css-extract-plugin
export var ArticleNav = "index-module--ArticleNav--ax2rP";
export var BackArrow = "index-module--BackArrow--OpbZ3";
export var BackLink = "index-module--BackLink--Q2Wwh";
export var DidYouKnow = "index-module--DidYouKnow--TVDYv";
export var DidYouKnowContent = "index-module--DidYouKnowContent--yTEFA";
export var pulseArrow = "index-module--pulseArrow--Nv23j";
export var revealNav = "index-module--revealNav--DvZAU";